function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useState } from 'react';
import { Box, Card, Column, Popover, SegmentControl } from 'seagull';
import { ColorPicker } from "../../../components/ColorPicker/ColorPicker";
import { ColorSelector } from "../../../components/ColorSelector/ColorSelector";
import { PRESET_GRADIENTS, PRESET_SOLID_COLORS } from "./brandingPresetColors";
import stylesPrimary from "./PrimaryBackgroundColorPopup.module.scss";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function PrimaryBackgroundColorPopup(props) {
  const {
    branding,
    hasError,
    onChange
  } = props;
  const start = branding.backgroundGradientStart;
  const end = branding.backgroundGradientEnd;
  const isSolid = start === end;
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeTab, setActiveTab] = useState(isSolid ? 'solid' : 'gradient');
  const displayBackground = isSolid ? start : "linear-gradient(225deg, ".concat(start, " 0%, ").concat(end, " 100%)");
  function applySolid(color) {
    onChange(_objectSpread(_objectSpread({}, branding), {}, {
      backgroundGradientStart: color,
      backgroundGradientEnd: color
    }));
  }
  function applyGradient(color1, color2) {
    onChange(_objectSpread(_objectSpread({}, branding), {}, {
      backgroundGradientStart: color1,
      backgroundGradientEnd: color2
    }));
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ColorSelector, {
      withBorder: true,
      color: displayBackground,
      hasError: hasError,
      testid: "color-selector-primary-background",
      onClick: e => setAnchorEl(e.currentTarget)
    }), /*#__PURE__*/_jsx(Popover, {
      anchorEl: anchorEl,
      open: !!anchorEl,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right'
      },
      transformOrigin: {
        vertical: -5,
        horizontal: 'right'
      },
      onClose: () => setAnchorEl(null),
      children: /*#__PURE__*/_jsx(Card, {
        className: stylesPrimary.popupCard,
        children: /*#__PURE__*/_jsxs(Column, {
          gap: 16,
          alignItems: "stretch",
          children: [/*#__PURE__*/_jsx(Box, {
            className: stylesPrimary.segmentControlWrapper,
            children: /*#__PURE__*/_jsx(SegmentControl, {
              options: [{
                value: 'gradient',
                label: 'Gradient',
                'data-testid': 'primary-bg-tab-gradient'
              }, {
                value: 'solid',
                label: 'Solid',
                'data-testid': 'primary-bg-tab-solid'
              }],
              value: activeTab,
              onChange: value => setActiveTab(value),
              variant: "text",
              "aria-label": "Primary background type",
              "data-testid": "primary-background-segment"
            })
          }), activeTab === 'gradient' ? /*#__PURE__*/_jsxs(Column, {
            gap: 24,
            className: stylesPrimary.tabContent,
            children: [/*#__PURE__*/_jsx(Box, {
              className: stylesPrimary.gradientGrid,
              children: PRESET_GRADIENTS.map((_ref, idx) => {
                let [c1, c2] = _ref;
                return /*#__PURE__*/_jsx(ColorSelector, {
                  withBorder: true,
                  color: "linear-gradient(225deg, ".concat(c1, " 0%, ").concat(c2, " 100%)"),
                  selected: start === c1 && end === c2,
                  testid: "gradient-preset-".concat(idx),
                  onClick: () => applyGradient(c1, c2)
                }, "".concat(c1, "-").concat(c2, "-").concat(idx));
              })
            }), /*#__PURE__*/_jsxs(Column, {
              gap: 24,
              children: [/*#__PURE__*/_jsx(ColorPicker, {
                colorAsSuffix: true,
                className: stylesPrimary.colorPickerFullWidth,
                inputWrapperClassName: stylesPrimary.primaryBgColorPickerInputWrapper,
                testid: "primary-bg-custom-color-1",
                label: "Custom color 1",
                color: start,
                displayColor: start,
                noMinWidth: true,
                onChange: c => applyGradient(c, end)
              }), /*#__PURE__*/_jsx(ColorPicker, {
                colorAsSuffix: true,
                className: stylesPrimary.colorPickerFullWidth,
                inputWrapperClassName: stylesPrimary.primaryBgColorPickerInputWrapper,
                label: "Custom color 2",
                testid: "primary-bg-custom-color-2",
                color: end,
                displayColor: end,
                noMinWidth: true,
                onChange: c => applyGradient(start, c)
              })]
            })]
          }) : /*#__PURE__*/_jsxs(Column, {
            gap: 24,
            className: stylesPrimary.tabContent,
            children: [/*#__PURE__*/_jsx(Box, {
              className: stylesPrimary.gradientGrid,
              children: PRESET_SOLID_COLORS.map((presetColor, idx) => /*#__PURE__*/_jsx(ColorSelector, {
                withBorder: true,
                color: presetColor,
                selected: presetColor.toLowerCase() === (start || '').toLowerCase(),
                testid: "solid-preset-".concat(idx),
                onClick: () => applySolid(presetColor)
              }, presetColor))
            }), /*#__PURE__*/_jsx(ColorPicker, {
              colorAsSuffix: true,
              className: stylesPrimary.colorPickerFullWidth,
              inputWrapperClassName: stylesPrimary.primaryBgColorPickerInputWrapper,
              testid: "primary-bg-solid-custom",
              color: start,
              noMinWidth: true,
              label: "Custom color",
              displayColor: start,
              onChange: applySolid
            })]
          })]
        })
      })
    })]
  });
}